import { render, staticRenderFns } from "./EnvelopeSolid.vue?vue&type=template&id=623e21c1"
import script from "./EnvelopeSolid.vue?vue&type=script&lang=ts"
export * from "./EnvelopeSolid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports